import React from 'react';
import {
  Table,
  Tooltip,
  Select,
  Button,
  InputNumber,
  DatePicker,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import Loading from '../../common/Loading';
import _ from 'lodash';

import { graphql, compose } from 'react-apollo';

import getTodosTiposSellos from '../../../graphql/querys/ventas/getTodosTiposSellos.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;

@compose(
  graphql(getOrganismos, { name: 'organismos' }),
  graphql(getTodosTiposSellos)
)
class FormCrearIngreso extends React.Component {
  constructor(props) {
    super(props);

    // let listaTiposSellos = this.props.data.getTiposSellos;
    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      listaTiposSellos: this.props.data.getTodosTiposSellos
        ? this.props.data.getTodosTiposSellos
        : [],
      itemsVenta: [],
      itemTipoSeleccionado: '',
      cantTipoSeleccionada: 0,
      numeracionFinal: 1,
      numeracionInicial: 0,
    };

    this.agregarItemVenta = this.agregarItemVenta.bind(this);
    this.devolverNombre = this.devolverNombre.bind(this);
    this.eliminarItem = this.eliminarItem.bind(this);
    this.calcularMontoTotal = this.calcularMontoTotal.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log("Voy a recibir nuevas props", nextProps);
    if (
      !this.props.data.getTodosTiposSellos &&
      nextProps.data.getTodosTiposSellos
    ) {
      this.setState(
        {
          ...this.state,
          listaTiposSellos: nextProps.data.getTodosTiposSellos,
        },
        function() {
          // console.log("Datos actualizados!")
        }
      );
    }
  }

  calcularMontoTotal() {
    // console.log("Entre a calcular el monto final");
    let montoFinal = 0;

    let yo = this;
    // console.log("El estado actual es de.....");
    // console.log(this.state);
    _.each(this.state.itemsVenta, function(item) {
      // console.log("entre a calcular con monto con...", item);
      var tipoSelloItem = _.find(yo.state.listaTiposSellos, function(
        tipoSello
      ) {
        // console.log("entre a buscar con....", tipoSello);
        return item.idTipo_Sello === tipoSello._id;
      });

      if (tipoSelloItem) {
        montoFinal = montoFinal + tipoSelloItem.valor * item.cantidad;
      }
    });

    // console.log("el monto final es...: ", montoFinal);
    return montoFinal;
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log("Received values of form: ", values);
        values.importe = this.calcularMontoTotal();
        values.detalle = this.state.itemsVenta;
        this.props.onSubmit(values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  handleChange = valor => {
    this.setState({
      ...this.state,
      itemTipoSeleccionado: valor,
    });
  };

  cambioNumero = valor => {
    this.setState({
      ...this.state,
      cantTipoSeleccionada: valor,
    });
  };

  cambioNumInicial = valor => {
    this.setState({
      ...this.state,
      numeracionInicial: valor,
    });
  };

  cambioNumFinal = valor => {
    this.setState({
      ...this.state,
      numeracionFinal: valor,
    });
  };

  agregarItemVenta() {
    let nuevoItemsVenta = this.state.itemsVenta;
    let nuevoDetalle = {
      idTipo_Sello: this.state.itemTipoSeleccionado,
      cantidad: this.state.numeracionFinal - this.state.numeracionInicial + 1,
      numeracionInicial: this.state.numeracionInicial,
      numeracionFinal: this.state.numeracionFinal,
    };
    nuevoItemsVenta.push(nuevoDetalle);

    //YA NO AGRUPAMOS MAS, POR EL TEMA DE LA NUMERACION DE LOS SELLOS

    // var output = _(nuevoItemsVenta)
    //   .groupBy("idTipo_Sello")
    //   .map((objs, key) => ({
    //     idTipo_Sello: key,
    //     cantidad: _.sumBy(objs, "cantidad")
    //   }))
    //   .value();

    this.setState({
      ...this.state,
      itemsVenta: nuevoItemsVenta,
      itemTipoSeleccionado: '',
      numeracionInicial: 0,
      numeracionFinal: 1,
    });
  }

  eliminarItem(idTipo_Sello, numInicial, numFinal) {
    let nuevoItemsVenta = this.state.itemsVenta;

    // console.log("ELiminar");
    // console.log(idTipo_Sello);
    // console.log(numInicial);
    // console.log(numFinal);
    // console.log(nuevoItemsVenta);

    _.remove(nuevoItemsVenta, {
      idTipo_Sello: idTipo_Sello,
      numeracionInicial: numInicial,
      numeracionFinal: numFinal,
    });

    this.setState({
      ...this.state,
      itemsVenta: nuevoItemsVenta,
    });
  }

  crearOpciones(tipoSello) {
    return (
      <Option key={tipoSello._id} value={tipoSello._id}>
        {tipoSello.nombre}
      </Option>
    );
  }

  crearOpcionesOrganismos = organismo => {
    return (
      <Option key={organismo._id} value={organismo._id}>
        {organismo.nombre}
      </Option>
    );
  };

  devolverNombre(idTipoSello) {
    let objeto = _.find(this.state.listaTiposSellos, { _id: idTipoSello });
    return objeto.nombre;
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const { opcionRender } = this.props; //Esta variable sirve para saber si se debe renderizar como form o como input
    let opcionFormulario = opcionRender ? opcionRender : 1;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let listaTiposSellos = this.props.data.getTodosTiposSellos;
    if (listaTiposSellos) {
      var opciones = _.map(listaTiposSellos, this.crearOpciones);
    } else {
      return <Loading />;
    }

    const listaOrganismos = this.props.organismos.getOrganismos;
    if (listaOrganismos) {
      var opcionesOrganismos = _.map(
        listaOrganismos,
        this.crearOpcionesOrganismos
      );
    }

    let columnasTabla = [];
    if (this.state.itemsVenta) {
      let yo = this;
      _.forEach(this.state.itemsVenta, function(value) {
        // console.log(value);
        columnasTabla.push({
          key: Math.random() * (10000000 - 1) + 1,
          nombre: yo.devolverNombre(value.idTipo_Sello),
          cantidad: value.numeracionFinal - value.numeracionInicial + 1,
          idTipo_Sello: value.idTipo_Sello,
          numeracionInicial: value.numeracionInicial,
          numeracionFinal: value.numeracionFinal,
        });
      });
    }

    return (
      <div>
        <h1 className="tituloForm">Datos del Envio</h1>

        {opcionFormulario == 0 && (
          <Form onSubmit={this.handleSubmit} className="formularios">
            <FormItem {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                Buscar
              </Button>
            </FormItem>
          </Form>
        )}

        {opcionFormulario == 1 && (
          <div>
            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Fecha del envio
                  <Tooltip title="Seleccione la fecha de que se efectuó el envio">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('fechaEnvio', {
                rules: [
                  {
                    type: 'object',
                    required: true,
                    message: 'Por favor, seleccione la fecha del envio',
                  },
                ],
              })(
                <DatePicker
                  style={{ width: 380 }}
                  placeholder="Fecha del envio"
                  format="DD/MM/YYYY"
                />
              )}
            </FormItem>

            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Organismo receptor del envio
                  <Tooltip title="Seleccione el organismo receptor">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('idOrganismoReceptor', {
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el organismo!',
                  },
                ],
              })(
                <Select
                  showSearch
                  style={{ width: 380 }}
                  placeholder="Seleccione un organismo"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {opcionesOrganismos}
                </Select>
              )}
            </FormItem>

            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Tipo Sello
                  <Tooltip title="Seleccione los sellos que fueron enviados">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              <div>
                <Select
                  showSearch
                  style={{ width: 380, marginRight: 20 }}
                  /* eslint-disable-next-line react/no-string-refs */
                  ref="selectTipoSello"
                  placeholder="Seleccione un tipo de tasa"
                  optionFilterProp="children"
                  onChange={this.handleChange}
                  value={this.state.itemTipoSeleccionado}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {opciones}
                </Select>
                {/* Cantidad:
                <InputNumber
                  onChange={this.cambioNumero}
                  ref="cantTipoSello"
                  style={{ marginLeft: 10, marginRight: 20 }}
                  min={1}
                  max={10000}
                /> */}
              </div>
            </FormItem>
            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Numeracion
                  <Tooltip title="Numeracion de los sellos enviados">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              <div>
                Inicial:
                <InputNumber
                  min={0}
                  max={99999999}
                  value={this.state.numeracionInicial}
                  onChange={this.cambioNumInicial}
                  style={{ marginLeft: 10, marginRight: 40, width: 125 }}
                />
                Final:
                <InputNumber
                  min={this.state.numeracionInicial + 1}
                  max={99999999}
                  value={this.state.numeracionFinal}
                  onChange={this.cambioNumFinal}
                  style={{ marginLeft: 10, marginRight: 20, width: 125 }}
                />
                <Button
                  type="primary"
                  onClick={this.agregarItemVenta}
                  disabled={!this.state.itemTipoSeleccionado}
                >
                  Agregar
                </Button>
              </div>
            </FormItem>
          </div>
        )}

        {this.state.itemsVenta.length > 0 && (
          <h1 style={{ textAlign: 'center', marginLeft: 55 }}>
            Detalle del Envio
          </h1>
        )}
        {this.state.itemsVenta.length > 0 && <hr />}
        {this.state.itemsVenta.length > 0 && (
          <Table
            style={{ maxWidth: 650, marginLeft: '20%' }}
            dataSource={columnasTabla}
            pagination={false}
            columns={[
              { title: 'Nombre', dataIndex: 'nombre', key: 'nombre' },
              { title: 'Cantidad', dataIndex: 'cantidad', key: 'cantidad' },
              {
                title: 'N° Inicial',
                dataIndex: 'numeracionInicial',
                key: 'numeracionInicial',
              },
              {
                title: 'N° Final',
                dataIndex: 'numeracionFinal',
                key: 'numeracionFinal',
              },
              {
                title: 'Acciones',
                key: 'acccion',
                render: record => (
                  <span>
                    <Button
                      type="danger"
                      onClick={() =>
                        this.eliminarItem(
                          record.idTipo_Sello,
                          record.numeracionInicial,
                          record.numeracionFinal
                        )
                      }
                    >
                      Eliminar
                    </Button>
                  </span>
                ),
              },
            ]}
          />
        )}

        {this.state.itemsVenta.length > 0 && (
          <h3 style={{ textAlign: 'center' }}>
            Monto Total:
            {this.calcularMontoTotal().toLocaleString('es-AR', {
              style: 'currency',
              currency: 'ARS',
            })}
          </h3>
        )}

        {this.state.itemsVenta.length > 0 && (
          <Button
            type="primary"
            style={{ textAlign: 'center', marginLeft: '45%' }}
            onClick={this.handleSubmit}
          >
            Generar Envio
          </Button>
        )}
      </div>
    );
  }
}

export default Form.create()(FormCrearIngreso);
